import { createSlice } from '@reduxjs/toolkit'

const UsersStatus = Object.freeze({
    LOADING: 'LOADING',
    SUCCESS: 'SUCCESS',
    FAILURE: 'FAILURE',
})

const initialState = {
    status: UsersStatus.LOADING,
    users: [],
    errorMessage: null,
    inviteStatus: UsersStatus.LOADING,
    inviteErrorMessage: null,
    deleteUserStatus: UsersStatus.LOADING,
    deleteUserErrorMessage: null,
}

const businessUsersSlice = createSlice({
    name: 'business/users',
    initialState,
    reducers: {
        getUsersRequest: state => {
            state.status = UsersStatus.LOADING
        },
        getUsersRequestSuccess: (state, action) => {
            state.status = UsersStatus.SUCCESS
            state.users = action.payload
        },
        getUsersRequestError: (state, action) => {
            state.status = UsersStatus.FAILURE
            state.errorMessage = action.payload
        },
        inviteUsersRequest: state => {
            state.inviteStatus = UsersStatus.LOADING
        },
        inviteUsersRequestSuccess: state => {
            state.inviteStatus = UsersStatus.SUCCESS
        },
        inviteUsersRequestError: (state, action) => {
            state.inviteStatus = UsersStatus.FAILURE
            state.inviteErrorMessage = action.payload
        },
        inviteUsersReset: state => {
            state.inviteStatus = UsersStatus.LOADING
            state.inviteErrorMessage = null
        },
        deleteUserRequest: state => {
            state.deleteUserStatus = UsersStatus.LOADING
        },
        deleteUserRequestSuccess: state => {
            state.deleteUserStatus = UsersStatus.SUCCESS
        },
        deleteUserRequestError: (state, action) => {
            state.deleteUserStatus = UsersStatus.SUCCESS
            state.deleteUserErrorMessage = action.payload
        },
        deleteUserReset: state => {
            state.deleteUserStatus = UsersStatus.LOADING
            state.deleteUserErrorMessage = null
        },
    },
})

const {
    getUsersRequest,
    getUsersRequestSuccess,
    getUsersRequestError,
    inviteUsersRequest,
    inviteUsersRequestSuccess,
    inviteUsersRequestError,
    inviteUsersReset,
    deleteUserRequest,
    deleteUserRequestSuccess,
    deleteUserRequestError,
    deleteUserReset,
} = businessUsersSlice.actions

export const businessUsersActions = {
    getUsersRequest,
    getUsersRequestSuccess,
    getUsersRequestError,
    inviteUsersRequest,
    inviteUsersRequestSuccess,
    inviteUsersRequestError,
    inviteUsersReset,
    deleteUserRequest,
    deleteUserRequestSuccess,
    deleteUserRequestError,
    deleteUserReset,
}

export const businessUsersSelectors = {
    isFetching: state => state.businessUsers.status === UsersStatus.LOADING,
    hasError: state => state.businessUsers.status === UsersStatus.FAILURE,
    errorMessage: state => state.businessUsers.errorMessage,
    users: state => state.businessUsers.users,
    inviteIsSubmitting: state =>
        state.businessUsers.inviteStatus === UsersStatus.LOADING,
    inviteHasError: state =>
        state.businessUsers.inviteStatus === UsersStatus.FAILURE,
    inviteErrorMessage: state => state.businessUsers.inviteErrorMessage,
    deleteUserIsSubmitting: state =>
        state.businessUsers.deleteUserStatus === UsersStatus.LOADING,
    deleteUserHasError: state =>
        state.businessUsers.deleteUserStatus === UsersStatus.FAILURE,
    deleteUserErrorMessage: state => state.businessUsers.deleteUserErrorMessage,
}

export default businessUsersSlice.reducer
